import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { Svojina } from './svojina';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-svojina-modal-update',
  templateUrl: './svojina-modal-update.component.html'
})
export class SvojinaModalUpdateComponent extends BaseModalUpdateComponent<Svojina> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Svojina>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
